<template>
  <div class="product">
    <main class="main" v-if="pcis">
      <div class="module">
        <div class="module-title">
          <span>
            蓝小助产品中心
          </span>
        </div>
        <div class="module-content">
          <div class="module-content-item" @mouseenter="itemEnter(1)" @mouseleave="leave(1)" ref="itemRef-1">
            <div class="item-text">
              <p class="item-title">招聘门户（公众号）</p>
              <div class="item-value">
                建立自己的长期招聘入口，沉淀普工资源
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/home.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(5)" @mouseleave="leave(5)" ref="itemRef-5">
            <div class="item-text">
              <p class="item-title">用工客服平台</p>
              <div class="item-value">
                专业的客服系统，不错过普工的每次咨询，客服下班后也能回复
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/kf-one.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(3)" @mouseleave="leave(3)" ref="itemRef-3">
            <div class="item-text">
              <p class="item-title">运营商短信群发</p>
              <div class="item-value">
                目标普工群体，一键招工
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/sms.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(4)" @mouseleave="leave(4)" ref="itemRef-4">
            <div class="item-text">
              <p class="item-title">微信高级群发</p>
              <div class="item-value">
                突破群发限制，轻松大批量招工
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/mass.png" alt="">
            </div>
          </div>
          
          <div class="module-content-item" @mouseenter="itemEnter(10)" @mouseleave="leave(10)" ref="itemRef-10">
            <div class="item-text">
              <p class="item-title">微信营销裂变招工</p>
              <div class="item-value">
                轻松实现短时间大批量招工，实现海量普工沉淀
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/fission.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(12)" @mouseleave="leave(12)" ref="itemRef-12">
            <div class="item-text">
              <p class="item-title">员工电子名片</p>
              <div class="item-value">
                专业的员工对外电子名片，轻松实现高效分享
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/card.png" alt="">
            </div>
          </div>
          
          <div class="module-content-item" @mouseenter="itemEnter(9)" @mouseleave="leave(9)" ref="itemRef-9">
            <div class="item-text">
              <p class="item-title">招聘粉丝海报</p>
              <div class="item-value">
                轻松策划和实施每一次招聘奖励活动 
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/fans-posters.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(11)" @mouseleave="leave(11)" ref="itemRef-11">
            <div class="item-text">
              <p class="item-title">渠道二维码</p>
              <div class="item-value">
                统计每个渠道的招聘效果
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/qr-code.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(2)" @mouseleave="leave(2)" ref="itemRef-2">
            <div class="item-text">
              <p class="item-title">智能招工</p>
              <div class="item-value">
                利用大数据技术，针对不同的普工智能推荐工作，提升成功率
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/phone.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(6)" @mouseleave="leave(6)" ref="itemRef-6">
            <div class="item-text">
              <p class="item-title">普工智能接待</p>
              <div class="item-value">
                24小时智能在线工作顾问，客服不在线也能回复普工咨询
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/kf-two.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(7)" @mouseleave="leave(7)" ref="itemRef-7">
            <div class="item-text">
              <p class="item-title">岗位发布和管理</p>
              <div class="item-value">
                招聘岗位的智能化管理
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/set-jobs.png" alt="">
            </div>
          </div>
          <div class="module-content-item" @mouseenter="itemEnter(8)" @mouseleave="leave(8)" ref="itemRef-8">
            <div class="item-text">
              <p class="item-title">自动化招聘</p>
              <div class="item-value">
                实现24小时报名确认，面试提醒，签到提醒
              </div>
            </div>
            <div class="item-img">
              <img src="@/assets/centre/automation.png" alt="">
            </div>
          </div>
        </div>
      </div>
    </main>
    <main class="main-move" v-else>
      <div class="module-move-title">
        <div>
          <p class="text">
          蓝小助产品中心
          </p>
          <p class="word">LAN XIAO ZHU CHANG PIN ZHONG XIN</p>
        </div>
      </div>
      <div class="module-content">
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">招聘门户（公众号）</p>
            <div class="item-value">
              建立自己的长期招聘入口，沉淀普工资源
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/home.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">用工客服平台</p>
            <div class="item-value">
              专业的客服系统，不错过普工的每次咨询，客服下班后也能回复
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/kf-one.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">运营商短信群发</p>
            <div class="item-value">
              目标普工群体，一键招工
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/sms.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">微信高级群发</p>
            <div class="item-value">
              突破群发限制，轻松大批量招工
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/mass.png" alt="">
          </div>
        </div>
        
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">微信营销裂变招工</p>
            <div class="item-value">
              轻松实现短时间大批量招工，实现海量普工沉淀
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/fission.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">员工电子名片</p>
            <div class="item-value">
              专业的员工对外电子名片，轻松实现高效分享
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/card.png" alt="">
          </div>
        </div>
        
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">招聘粉丝海报</p>
            <div class="item-value">
              轻松策划和实施每一次招聘奖励活动 
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/fans-posters.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">渠道二维码</p>
            <div class="item-value">
              统计每个渠道的招聘效果
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/qr-code.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">智能招工</p>
            <div class="item-value">
              利用大数据技术，针对不同的普工智能推荐工作，提升成功率
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/phone.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">普工智能接待</p>
            <div class="item-value">
              24小时智能在线工作顾问，客服不在线也能回复普工咨询
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/kf-two.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">岗位发布和管理</p>
            <div class="item-value">
              招聘岗位的智能化管理
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/set-jobs.png" alt="">
          </div>
        </div>
        <div class="module-content-item">
          <div class="item-text">
            <p class="item-title">自动化招聘</p>
            <div class="item-value">
              实现24小时报名确认，面试提醒，签到提醒
            </div>
          </div>
          <div class="item-img">
            <img src="@/assets/centre/automation.png" alt="">
          </div>
        </div>
      </div>
    </main>
  </div>
</template>
<script>
export default {
  data () {
    return {
      pcis: this.$store.state.pcIs, // 根据窗口大小变化来判断移动端PC端
    }
  },
  methods: {
    itemEnter (index) {
      this.$refs[`itemRef-` + index].style.transition = "top 0.5s"
      this.$refs[`itemRef-` + index].style.top = "-5px"
    },
    leave (index) {
      this.$refs[`itemRef-` + index].style.top = "0"
    
    }
  }
};
</script>
<style lang="less" scoped>
.product {
  background: #f5f6fd;
  position: relative;
  z-index: 2;
  .bannder {
    width: 100%;
    height: 100%;
    img {
      width: 100%;
      margin: 0 auto;
    }
  }
  .main {
    width: 1200px;
    margin: auto;
  }
  .module {
      width: 1200px;
      padding: 0 15px;
      margin: auto;
    .module-title{
      text-align: center;
      font-size: 30px;
      font-weight: 800;
      color: #454545;
      line-height: 50px;
      margin-top: 50px;
      >span {
        position: relative;
        display: inline-block;
        // padding-bottom: 10px;
        // border-bottom: 2px solid #d5d5d5;
        >span {
          position: absolute;
          left: 20%;
          bottom: -4px;
          display: inline-block;
          width: 60%;
          background: #04A8FF;
          border: 3px solid #04A8FF
        }
      }
    }
    .module-content {
      display: flex;
      flex-wrap: wrap;
      margin-top: 40px;
      padding-bottom: 45px;
      justify-content: space-between;
      .module-content-item {
        position: relative;
        top: 0;
        width: 48%;
        height: 130px;
        background: #fff;
        display: flex;
        padding: 20px 30px;
        margin-bottom: 26px;
        box-sizing: border-box;
        border-radius: 6px;
        box-shadow: 0px 25px 36px 0px rgba(0, 0, 0, 0.07);
        .item-text {
          flex: 1;
          font-size: 14px;
          font-family: SourceHanSansCN-Regular, SourceHanSansCN;
          font-weight: 400;
          color: #999;
          line-height: 19px;
          .item-title {
            font-size: 20px;
            font-weight: bold;
            color: #333333;
            line-height: 33px;
            margin-bottom: 8px;
          }
        }
        .item-img {
          width: 100px;
          display: flex;
          justify-content: flex-end;
          >img {
            width: 89px;
            height: 89px;
          }
        }
      }
    }
  }
}
</style>
<style lang="less" scoped>
p {
  margin: 0;
}
// 移动端
.main-move {
  width: 100%;
  .module-move-title {
    width: 100%;
    background: url('~@/assets/product-center-bg.png');
    background-size: 100% 100%;
    height: 414px;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
    .text {
      font-size: 83px;
      font-weight: normal;
      color: #FFFFFF;
      line-height:115px;
    }
    .word {
      font-size: 26px;
      color: #FFFFFF;
      line-height: 35px;
    }
  }
  .module-content {
    display: flex;
    flex-wrap: wrap;
    margin-top: 109px;
    padding: 0 51px 45px;
    justify-content: space-between;
    .module-content-item {
      position: relative;
      top: 0;
      width: 100%;
      height: 248px;
      background: #fff;
      display: flex;
      padding: 37px 56px;
      margin-bottom: 29px;
      box-sizing: border-box;
      border-radius: 12px;
      box-shadow: 0px 25px 36px 0px rgba(0, 0, 0, 0.07);
      .item-text {
        flex: 1;
        font-size: 35px;
        font-family: SourceHanSansCN-Regular, SourceHanSansCN;
        font-weight: 400;
        color: #666666;
        line-height: 42px;
        .item-title {
          font-size: 48px;
          font-weight: bold;
          color: #333333;
          line-height: 67px;
          margin-bottom: 19px;
        }
      }
      .item-img {
        width: 300px;
        display: flex;
        justify-content: flex-end;
        >img {
          width: 173px;
          height: 173px;
        }
      }
    }
  }
}
</style>

